import { en, de, fr, it } from '@formkit/i18n'
import { DefaultConfigOptions } from '@formkit/vue'

const config: DefaultConfigOptions = {
  locales: { en, de, fr, it },
  locale: 'de',
}

export default config
